import ReactDatePicker from "../../../../../components/reactDatePicker/reactDatePicker";
import { connect } from "react-redux";
import { actionCreators } from "../redux/sagas/multiLocation/multiLocation";

export default connect(
  (state) => ({
    isRangePicker: true,
    startDate: state.multiLocation.selectedRequestDates.startDate,
    endDate: state.multiLocation.selectedRequestDates.endDate,
    calendarEndDate: state.multiLocation.currentUser.params.calendarEndDate,
    minDate: state.multiLocation.currentUser.params.calendarStartDate
  }),
  {
    updateDates: (startDate, endDate) =>
      actionCreators.updateDates({ startDate: startDate, endDate: endDate })
  }
)(ReactDatePicker);
